import React from 'react'

const UCCallRecording = () => {
  return (
    <div>
              <iframe
        src={"https://avayaucj.inaipi.me/CallRecording/Login.aspx?UserName=NWSupervisor&Password=Sample@123"}
        style={{ width: "100vw", height: "90vh" }}
      ></iframe>
    </div>
  )
}

export default UCCallRecording